import MarkdownEditor from '@uiw/react-markdown-editor';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import remarkGfm from "remark-gfm";

const MarkdownBlock = ({
  isEditMode,
  value,
  onChange
}: {
  isEditMode: boolean,
  value: string,
  onChange: (value: string) => void
}) => {

  if (isEditMode) {
    return <MarkdownEditor
      className='border'
      basicSetup={{
        lineNumbers: false,
      }}
      minHeight="300px"
      maxHeight="600px"
      height="100%"
      theme='light'
      maxWidth="100%"
      value={value || ''}
      onChange={onChange} />
  }

  return <ReactMarkdown
    remarkPlugins={[remarkGfm]}
  >
    {value || ''}
  </ReactMarkdown>
}

export default MarkdownBlock;